/**
 * @generated SignedSource<<a79722fedf363a6d68e486b2a25c9b8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StartContentConfigType = "StartContent_CanAfterStartingTree" | "StartContent_CanIfCertificationUnlocked" | "StartContent_CanIfInTreeFlow" | "StartContent_CanIfUnlocked" | "StartContent_CanNDaysAfterStartingTree" | "StartContent_CanNot";
export type AddCanAfterNDaysStartingTreeStartContentConfigInput = {
  clientMutationId?: string | null;
  contentId: string;
  days: number;
};
export type startContentConfigEditor_AddCanAfterNDaysStartContentConfigMutation$variables = {
  input: AddCanAfterNDaysStartingTreeStartContentConfigInput;
};
export type startContentConfigEditor_AddCanAfterNDaysStartContentConfigMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly addCanNDaysAfterStartingTreeStartContentConfig: {
        readonly content: {
          readonly id: string;
          readonly rootId: string;
          readonly typeDefinition: {
            readonly startConfigs?: ReadonlyArray<{
              readonly configType: StartContentConfigType;
              readonly days?: number;
              readonly id: string;
            }>;
          };
        };
      } | null;
    };
  };
};
export type startContentConfigEditor_AddCanAfterNDaysStartContentConfigMutation = {
  response: startContentConfigEditor_AddCanAfterNDaysStartContentConfigMutation$data;
  variables: startContentConfigEditor_AddCanAfterNDaysStartContentConfigMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rootId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "configType",
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "days",
      "storageKey": null
    }
  ],
  "type": "CanNDaysAfterStartingTreeStartContentConfig",
  "abstractKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "startContentConfigEditor_AddCanAfterNDaysStartContentConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddCanAfterNDaysStartingTreeStartContentConfigPayload",
                "kind": "LinkedField",
                "name": "addCanNDaysAfterStartingTreeStartContentConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "startConfigs",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/),
                                  (v4/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ELearningContentTypeDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "startContentConfigEditor_AddCanAfterNDaysStartContentConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddCanAfterNDaysStartingTreeStartContentConfigPayload",
                "kind": "LinkedField",
                "name": "addCanNDaysAfterStartingTreeStartContentConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "startConfigs",
                                "plural": true,
                                "selections": [
                                  (v6/*: any*/),
                                  (v2/*: any*/),
                                  (v4/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ELearningContentTypeDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ce11a08ba25711ccfac2b4ea9b0c1368",
    "id": null,
    "metadata": {},
    "name": "startContentConfigEditor_AddCanAfterNDaysStartContentConfigMutation",
    "operationKind": "mutation",
    "text": "mutation startContentConfigEditor_AddCanAfterNDaysStartContentConfigMutation(\n  $input: AddCanAfterNDaysStartingTreeStartContentConfigInput!\n) {\n  Admin {\n    Tree {\n      addCanNDaysAfterStartingTreeStartContentConfig(input: $input) {\n        content {\n          id\n          rootId\n          typeDefinition {\n            __typename\n            ... on ELearningContentTypeDefinition {\n              startConfigs {\n                __typename\n                id\n                configType\n                ... on CanNDaysAfterStartingTreeStartContentConfig {\n                  days\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "51ed3d9d6ce47d337a76df00e1e19251";

export default node;
